import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "header" }
const _hoisted_2 = { class: "subheader" }
const _hoisted_3 = { class: "start" }
const _hoisted_4 = { class: "kennels" }
const _hoisted_5 = { class: "dogs" }
const _hoisted_6 = ["onUpdate:modelValue"]
const _hoisted_7 = { class: "total" }
const _hoisted_8 = ["onUpdate:modelValue"]
const _hoisted_9 = { class: "available" }
const _hoisted_10 = { class: "save-button" }
const _hoisted_11 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "card-base",
    id: "kennel-modal",
    onClick: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["stop"]))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _cache[4] || (_cache[4] = _createElementVNode("div", { class: "header-3" }, "Kennel Availability", -1)),
      _createElementVNode("button", {
        class: "button-close",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
      }, _cache[3] || (_cache[3] = [
        _createElementVNode("svg", {
          class: "icon close",
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, [
          _createElementVNode("path", {
            class: "fill",
            d: "M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12L19 6.41Z"
          })
        ], -1)
      ]))
    ]),
    _createElementVNode("div", _hoisted_2, [
      _cache[6] || (_cache[6] = _createElementVNode("div", { class: "effective" }, "Effective:", -1)),
      _createElementVNode("div", _hoisted_3, [
        _createTextVNode(_toDisplayString(new Date($props.date.year, $props.date.month, $props.date.day).toLocaleDateString()), 1),
        _cache[5] || (_cache[5] = _createStaticVNode("<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><g clip-path=\"url(#clip0_1438_8075)\"><path d=\"M19 4H18V2H16V4H8V2H6V4H5C3.89 4 3.01 4.9 3.01 6L3 20C3 21.1 3.89 22 5 22H19C20.1 22 21 21.1 21 20V6C21 4.9 20.1 4 19 4ZM19 20H5V10H19V20ZM9 14H7V12H9V14ZM13 14H11V12H13V14ZM17 14H15V12H17V14ZM9 18H7V16H9V18ZM13 18H11V16H13V18ZM17 18H15V16H17V18Z\" fill=\"#676772\"></path></g><defs><clipPath id=\"clip0_1438_8075\"><rect width=\"24\" height=\"24\" fill=\"white\"></rect></clipPath></defs></svg>", 1))
      ])
    ]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.Dogspaces.Sizes, (size) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "size-container",
        key: size
      }, [
        _createElementVNode("span", {
          class: _normalizeClass(size)
        }, _toDisplayString($setup.Dogspaces.SizeTitle[size]), 3),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": ($event: any) => (($setup.givenCounts[size]) = $event),
              type: "text"
            }, null, 8, _hoisted_6), [
              [_vModelText, $setup.givenCounts[size]]
            ]),
            _cache[7] || (_cache[7] = _createElementVNode("div", { class: "label" }, "Dogs", -1))
          ]),
          _cache[9] || (_cache[9] = _createElementVNode("div", { class: "divider" }, "/", -1)),
          _createElementVNode("div", _hoisted_7, [
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": ($event: any) => (($setup.givenMax[size]) = $event),
              type: "text"
            }, null, 8, _hoisted_8), [
              [_vModelText, $setup.givenMax[size]]
            ]),
            _cache[8] || (_cache[8] = _createElementVNode("div", { class: "label" }, "Total", -1))
          ])
        ]),
        _createElementVNode("div", _hoisted_9, _toDisplayString($setup.givenMax[size] - $setup.givenCounts[size]) + " Available", 1)
      ]))
    }), 128)),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("button", {
        class: "secondary outline",
        disabled: !$setup.hasChanged,
        onClick: $setup.doUpdate
      }, "Save", 8, _hoisted_11)
    ]),
    ($setup.bulkEdit)
      ? (_openBlock(), _createBlock($setup["BulkEdit"], {
          key: 0,
          "dog-type": $setup.bulkEdit,
          "from-date": new Date($props.date.year, $props.date.month, $props.date.day),
          onClose: _cache[1] || (_cache[1] = ($event: any) => ($setup.bulkEdit = null))
        }, null, 8, ["dog-type", "from-date"]))
      : _createCommentVNode("", true)
  ]))
}